export const GET_LOGIN_USER_INFO = 'GET_LOGIN_USER_INFO'
export const GET_LOGIN_USER_INFO_SUCCESS = 'GET_LOGIN_USER_INFO_SUCCESS'
export const GET_LOGIN_USER_INFO_ERROR = 'GET_LOGIN_USER_INFO_ERROR'

//配置页面
export const GET_EDIT = 'GET_EDIT'
export const GET_EDIT_SUCCESS = 'GET_EDIT_SUCCESS'
export const GET_EDIT_ERROR = 'GET_EDIT_ERROR'

//权限配置
export const GET_PERMISSION = 'GET_PERMISSION'
export const GET_PERMISSION_SUCCESS = 'GET_PERMISSION_SUCCESS'
export const GET_PERMISSION_ERROR = 'GET_PERMISSION_ERROR'

//当前切换的数据权限chekbox
export const GET_CURRENT_TOGGLE_CHECKBOX_ITEM = 'GET_CURRENT_TOGGLE_CHECKBOX_ITEM'
export const GET_CURRENT_TOGGLE_CHECKBOX_ITEM_SUCCESS = 'GET_CURRENT_TOGGLE_CHECKBOX_ITEM_SUCCESS'
export const GET_CURRENT_TOGGLE_CHECKBOX_ITEM_ERROR = 'GET_CURRENT_TOGGLE_CHECKBOX_ITEM_ERROR'

// 选人组件
export const GET_USER_LIST = 'GET_USER_LIST'
export const GET_USER_LIST_SUCCESS = 'GET_USER_LIST_SUCCESS'
export const GET_USER_LIST_ERROR = 'GET_USER_LIST_ERROR'

// 选群主组件
export const GET_GROUP_LIST = 'GET_USER_LIST'
export const GET_GROUP_LIST_SUCCESS = 'GET_USER_LIST_SUCCESS'
export const GET_GROUP_LIST_ERROR = 'GET_USER_LIST_ERROR'

// 消息存档设置 - 默认的违规类型
export const GET_DEFAULT_LIST = 'GET_DEFAULT_LIST'
export const GET_DEFAULT_LIST_SUCCESS = 'GET_DEFAULT_LIST_SUCCESS'
export const GET_DEFAULT_LIST_ERROR = 'GET_DEFAULT_LIST_ERROR'

// 消息存档 - 添加敏感词,获得当前点击了’添加‘按钮的敏感词
export const GET_CURRENT_INPUT_WORDS = 'GET_CURRENT_INPUT_ITEM'
export const GET_CURRENT_INPUT_WORDS_SUCCESS = 'GET_CURRENT_INPUT_WORDS_SUCCESS'
export const GET_CURRENT_INPUT_WORDS_ERROR = 'GET_CURRENT_INPUT_WORDS_ERROR'

// 消息存档 - 企业消息存档是否可用
export const GET_MESSAGE_SETTINGS_OPEN = 'GET_MESSAGE_SETTINGS_OPEN'
export const GET_MESSAGE_SETTINGS_OPEN_SUCCESS = 'GET_MESSAGE_SETTINGS_OPEN_SUCCESS'
export const GET_MESSAGE_SETTINGS_OPEN_ERROR = 'GET_MESSAGE_SETTINGS_OPEN_ERROR'

// 三方会话存档
export const GET_THRID_CHAT_OPEN = 'GET_THRID_CHAT_OPEN'
export const GET_THRID_CHAT_OPEN_SUCCESS = 'GET_THRID_CHAT_OPEN_SUCCESS'
export const GET_THRID_CHAT_OPEN_ERROR = 'GET_THRID_CHAT_OPEN_ERROR'
// 三方会话存档-自建应用购买
export const GET_COM_NOEXPIRE_OPEN = 'GET_COM_NOEXPIRE_OPEN'
export const GET_COM_NOEXPIRE_OPEN_SUCCESS = 'GET_COM_NOEXPIRE_OPEN_SUCCESS'
export const GET_COM_NOEXPIRE_OPEN_ERROR = 'GET_COM_NOEXPIRE_OPEN_ERROR'

// 企业授权
export const GET_COM_AUTH = 'GET_COM_AUTH'
export const GET_COM_AUTH_SUCCESS = 'GET_COM_AUTH_SUCCESS'
export const GET_COM_AUTH_ERROR = 'GET_COM_AUTH_ERROR'
// 自建应用配置信息
export const GET_MESSAGE_OPEN = 'GET_MESSAGE_OPEN'
export const GET_MESSAGE_OPEN_SUCCESS = 'GET_MESSAGE_OPEN_SUCCESS'
export const GET_MESSAGE_OPEN_ERROR = 'GET_MESSAGE_OPEN_ERROR'

// 消息存档配置引导 - 当前填入的相关信息
export const GET_MESSAGE_GUIDANCE_SELECT_VALUE = 'GET_MESSAGE_GUIDANCE_SELECT_VALUE'
export const GET_MESSAGE_GUIDANCE_SELECT_VALUE_SUCCESS = 'GET_MESSAGE_GUIDANCE_SELECT_VALUE_SUCCESS'
export const GET_MESSAGE_GUIDANCE_SELECT_VALUE_ERROR = 'GET_MESSAGE_GUIDANCE_SELECT_VALUE_ERROR'

// crm操作权限
export const CRM_PERMISSION = 'CRM_PERMISSION'
export const CRM_PERMISSION_SUCCESS = 'CRM_PERMISSION_SUCCESS'
export const CRM_PERMISSION_ERROR = 'CRM_PERMISSION_ERROR'

// crm整个模块是否授权
export const CRM_MODULE_PERMISSION = 'CRM_MODULE_PERMISSION'
export const CRM_MODULE_PERMISSION_SUCCESS = 'CRM_MODULE_PERMISSION_SUCCESS'
export const CRM_MODULE_PERMISSION_ERROR = 'CRM_MODULE_PERMISSION_ERROR'

// globalConfig配置
export const GLOBAL_CONFIG = 'GLOBAL_CONFIG'
export const GLOBAL_CONFIG_SUCCESS = 'GLOBAL_CONFIG_SUCCESS'
export const GLOBAL_CONFIG_ERROR = 'GLOBAL_CONFIG_ERROR'

// 群成员打标签全局提示状态
export const MODAL_Flag = 'MODAL_Flag'
export const MODAL_Flag_SUCCESS = 'MODAL_Flag_SUCCESS'
export const MODAL_Flag_ERROR = 'MODAL_Flag_ERROR'

// 是否显示侧边栏及头部
export const HEADER_ISSHOW = 'HEADER_ISSHOW'
export const HEADER_ISSHOW_SUCCESS = 'HEADER_ISSHOW_SUCCESS'
export const HEADER_ISSHOW_ERROR = 'HEADER_ISSHOW_ERROR'

// 请求接口是否需要loading
export const REQUEST_LOADING = 'REQUEST_LOADING'
export const REQUEST_LOADING_SUCCESS = 'REQUEST_LOADING_SUCCESS'
export const REQUEST_LOADING_ERROR = 'REQUEST_LOADING_ERROR'

// BMS权限
export const BMS_VERSION = 'BMS_VERSION'
export const BMS_VERSION_SUCCESS = 'BMS_VERSION_SUCCESS'
export const BMS_VERSION_ERROR = 'BMS_VERSION_ERROR'

//千牛上传获取百分比
export const QN_PROGRESS = 'QN_PROGRESS'
export const QN_PROGRESS_SUCCESS = 'QN_PROGRESS_SUCCESS'
export const QN_PROGRESS_ERROR = 'QN_PROGRESS_ERROR'

// 消息存档 - 当前用户消息存档是否可用
export const GET_MESSAGE_SETTINGS_OPEN_USER = 'GET_MESSAGE_SETTINGS_OPEN'
export const GET_MESSAGE_SETTINGS_OPEN_SUCCESS_USER = 'GET_MESSAGE_SETTINGS_OPEN_SUCCESS'
export const GET_MESSAGE_SETTINGS_OPEN_ERROR_USER = 'GET_MESSAGE_SETTINGS_OPEN_ERROR'


//签名设置
export const AGENT_CONFIG = 'AGENT_CONFIG'
export const AGENT_CONFIG_SUCCESS = 'AGENT_CONFIG_SUCCESS'
export const AGENT_CONFIG_ERROR = 'AGENT_CONFIG_ERROR'